import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Pagination from "../generic-ui/Pagination";
import Select from "../generic-ui/Select";
import NavbarIconsCatalogRoles from "../generic-nav-bar/NavbarIconsCatalogRoles";
import {
  catalogRoleCleanSearchText,
  catalogRoleStartDelete,
  cleanSearchingCatalogRolesPaginated,
  selectCatalogRoles,
  startLoadingCatalogRolesPaginated,
  startSearchingCatalogRolePaginated,
} from "../../app/actions/catalogRoleActions";
import SearchBackCatalogRole from "../generic-search/SearchBackCatalogRole";

import { useTracking } from "react-tracking";
import { useTranslation } from "react-i18next";
import TableCatalogRoles from "./TableCatalogRoles";
import { debugLogPages } from "../../app/helpers/debugHelper";

const ID_FORM = "admin-catalog-role";
const OPERATION = "list";

const listOptions = [2, 3, 4, 5, 10, 15, 20, 25, 50, 100];

const ListCatalogRoles = () => {
  debugLogPages(':: ListCatalogRoles'); 

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { trackEvent } = useTracking();
  const { t } = useTranslation();

  const { searchTextState, catalogRolesS, catalogRolesP, totalPagesP, totalItemsP, currentPageP, totalPagesS, totalItemsS, currentPageS } =
    useSelector((state) => state.catalogRole);

  const [, setCurrentPageClick] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [pageInitial] = useState(0);
  const [searchText, setSearchText] = useState(searchTextState || "");

  useEffect(() => {
    //First Clean list and searchText
    dispatch(cleanSearchingCatalogRolesPaginated());
    dispatch(catalogRoleCleanSearchText());
    //Load Data
    dispatch(startLoadingCatalogRolesPaginated(pageInitial, itemsPerPage));
    setSearchText("");
  }, []);

  const onEditRow = (row) => {
    trackEvent({ component: "EditCatalogRoles", method: "onEditRow", event: "EditCatalogRoles-Clicked" });

    dispatch(selectCatalogRoles(row));
    if (catalogRolesS?.length > 0) {
      navigate("/admin-catalog-role/edit-catalog-role", {
        state: { searchTextNavListUser: searchText },
      });
    } else {
      navigate("/admin-catalog-role/edit-catalog-role");
    }
  };

  const onDeleteRow = (row) => {
    trackEvent({ component: "DeleteCatalogRoles", method: "onDeleteRow", event: "DeleteCatalogRoles-Clicked" });
    dispatch(catalogRoleStartDelete(row.id));
  };

  const onPageChange = (pageClick) => {
    
    if (catalogRolesS && catalogRolesS.length > 0) {
      dispatch(startSearchingCatalogRolePaginated(searchText, pageClick - 1, itemsPerPage));
    } else {
      dispatch(startLoadingCatalogRolesPaginated(pageClick - 1, itemsPerPage));
    }
    setCurrentPageClick(pageClick);
  };

  const onChangeSelect = (event) => {
    setItemsPerPage(event.target.value);
    if (catalogRolesS && catalogRolesS.length > 0) {
      dispatch(startSearchingCatalogRolePaginated(searchText, 0, event.target.value));
    } else {
      dispatch(startLoadingCatalogRolesPaginated(0, event.target.value));
    }
    setCurrentPageClick(0);
    setItemsPerPage(event.target.value);
  };

  return (
    <>
      <NavbarIconsCatalogRoles page={"listCatalogRoles"} />

      <div className="d-flex justify-content-center page-title">{t(`${ID_FORM}.page.${OPERATION}`)}</div>

      <hr className="line-hr" />

      <SearchBackCatalogRole searchText={searchText} setSearchText={setSearchText} itemsPerPage={itemsPerPage} />

      {catalogRolesS && catalogRolesS.length > 0 ? (
        <TableCatalogRoles data={catalogRolesS} onEditRow={onEditRow} onDeleteRow={onDeleteRow} />
      ) : (
        <TableCatalogRoles data={catalogRolesP} onEditRow={onEditRow} onDeleteRow={onDeleteRow} />
      )}

      <div>
        <Select listOptions={listOptions} onChangeSelect={onChangeSelect} pageSize={itemsPerPage} />
      </div>

      <div className="pagination justify-content-center">
        {catalogRolesS && catalogRolesS.length > 0 ? (
          <Pagination
            totalPages={totalPagesS}
            totalItems={totalItemsS}
            currentPage={currentPageS + 1} 
            itemsPerPage={itemsPerPage}
            onPageChange={onPageChange}
          />
        ) : (
          <Pagination
            totalPages={totalPagesP}
            totalItems={totalItemsP}
            currentPage={currentPageP + 1} 
            itemsPerPage={itemsPerPage}
            onPageChange={onPageChange}
          />
        )}
      </div>
    </>
  );
};

export default ListCatalogRoles;
